//utility for nested strings in column orderBy / column searchBy
//this handles cases where the value is nested within the data object
function fetchFromObject(obj, prop) {
    const _index = prop.indexOf('.');
    if (_index > -1) {
        return fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }
    return obj[prop];
}
export function TableColumnFilter() {
    return function (values, columns) {
        let result = values;
        columns.forEach(function (col) {
            // if a column has an orderBy already use that. otherwise a searchBy can be specified.
            const colId = col.orderBy ? col.orderBy : col.searchBy;
            //if an orderBy or searchBy value is set and the column filter has a value, it will filter on that column
            if (colId && col.filter) {
                //filter the current set of values
                result = result.filter(function (row) {
                    const val = fetchFromObject(row, colId);
                    return val && val.toString().toLowerCase().indexOf(col.filter.toLowerCase()) !== -1;
                });
            }
        });
        return result;
    };
}
